import { SelectItem } from '@yandex-360/orb-components/dist/components/Select2';
import { groupBy } from 'lodash';

import { i18n } from '../../../../../shared/helpers/i18n';
import { ArtifactRecipient } from '../../fetching/types';

export const getArtifactRecipientsSelectItems = (
    recipients: ArtifactRecipient[]
): SelectItem<string | number | null>[] => {
    if (recipients.length === 0) return [];
    const groupedRecipients = groupBy(recipients, 'role');
    const items = [];
    if (groupedRecipients.OWNER) {
        const owner = groupedRecipients.OWNER[0];
        items.push({
            label: i18n('conferences-history', 'owner'),
            showDivider: true,
            options: [{ itemKey: owner.email, label: owner.displayName }],
        });
    }
    if (groupedRecipients.ADMIN) {
        items.push({
            label: i18n('conferences-history', 'admins'),
            showDivider: true,
            options: groupedRecipients.ADMIN.map((admin) => ({
                itemKey: admin.email,
                label: admin.displayName,
            })),
        });
    }
    if (groupedRecipients.MEMBER) {
        items.push({
            label: i18n('conferences-history', 'members'),
            options: groupedRecipients.MEMBER.map((member) => ({
                itemKey: member.email,
                label: member.displayName,
            })),
        });
    }
    items[items.length - 1].showDivider = false;
    return items;
};
